import { render, staticRenderFns } from "./Blockly.vue?vue&type=template&id=f3b80c1e"
import script from "./Blockly.vue?vue&type=script&lang=js"
export * from "./Blockly.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports